// extracted by mini-css-extract-plugin
export default {"passenger_row":"PassengerRow_passenger_row__P0iBZ","action_button":"PassengerRow_action_button__4eepl"};